import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ThemeAssetComponent } from '@partners/themes';

import { TResponsiveSize } from '../../model/ui.types';
import { toggleCheckAnimation } from './animations';

@Component({
  standalone: true,
  selector: 'check-indicator',
  template: ` <div [@toggleCheckAnimation]="show"><theme-asset asset="filled-check-icon"></theme-asset></div> `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [toggleCheckAnimation],
  imports: [ThemeAssetComponent],
  host: {
    class: 'check-indicator'
  }
})
export class CheckIndicatorComponent implements OnInit {
  @Input()
  show: boolean;

  /** comply with preset responsive ui sizes */
  @Input()
  @HostBinding('class')
  size: TResponsiveSize;

  constructor() {}

  ngOnInit(): void {}
}
